module.exports = __webpack_public_path__ + "static/media/logo-dark.d6276a62.png";